const baseConfig = {
  name: 'onboarding-modal',
  featureFlag: 'cve_onboarding_modal',
  paths: /^\/(my-va\/?)?$/,
  requiresAuth: true,
  requiresLOA3: true,
};

export default baseConfig;
